

import styled from "styled-components"
import PageTopTitle from "../../components/shared/PageTopTitle"
import { useState } from "react"
import { useSearchParams } from "react-router-dom"
import { useSelector } from "react-redux"
import { useEffect } from "react"
import { useDispatch } from "react-redux"
import { getKKK } from "../../features/adminSett/adminSettSlice"
import textBoldMaker from "../../helper/textBoldMaker"

const Container = styled.div`
width: 100%;

.wrapper{
    display: flex;
    flex-direction: column;
    width: 100%;

    .content{
      width: calc(100% - 60px);
      gap: 60px;
      margin: 30px;
      display: flex;
      justify-content: center;
    }

    .list{
        width: 80%;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 15px;

        .item{
            padding: 20px;
            background-color: ${({ theme }) => theme.secondaryBgColor};
            width: 100%;
            border-radius: 5px;
            color: ${({theme}) => theme.mainTextColor};
            display: flex;
            gap: 5px;
            font-weight: var(--font-weight-md);
            font-size: var(--font-md-md);
            line-height: 1.5;
            
            .bold{
                font-weight: var(--font-weight-xl);
            }

        }


    }
}

@media (max-width: 850px){
  .list{
    width: 100% !important;
    gap: 20px !important;
    .item{
      padding: 10px !important;
    }
  }
  
}
`

const KamyonKullanimKurallari = () => {
    const {KKKList} = useSelector(state => state.adminSett)
    const dispatch = useDispatch()
  
      useEffect(()=> {
        dispatch(getKKK())
      },[])
  
  return (
    <Container>
    <div className="wrapper">
      <PageTopTitle title={"Kamyoon Kullanım Kuralları"} position='sticky'/>
      <div className="content">
        <div className="list">
            {
              KKKList.map((item) => (
                <div className="item">
                    <div className="order">{item.termsOrder}-</div>
                    <div className="item-text" dangerouslySetInnerHTML={{ __html: textBoldMaker(item.terms) }}/>
                </div>
              ))
            }
        </div>
      </div>
    </div>
  </Container>
  )
}

export default KamyonKullanimKurallari